<template>
	<div v-once class="web-access-not-allowed">
		<div class="web-access-not-allowed__content">
			<h1>Web Access Not Allowed</h1>
			<p>
				This application is not designed to be accessed via a web
				browser.
			</p>
			<p>Please use a mobile app to access this application.</p>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.web-access-not-allowed {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	z-index: 1000;
	background-color: #f5f5f5;
	height: 100vh;
	color: #333;
	text-align: center;

	.web-access-not-allowed__content {
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
		border-radius: 8px;
		background-color: #fff;
		padding: 20px;
		max-width: 600px;

		h1 {
			margin-bottom: 10px;
			font-size: 2rem;
		}

		p {
			margin-bottom: 10px;
			font-size: 1rem;
		}
	}
}
</style>
